<template>
    <BaseModal
        :name="props.name"
        :closeOutside="true"
        class="modal-success"
    >
        <template v-slot:content>
            <IconButton icon="check" class="round size-xl animate-1" @click="animateItAgainPlease" />

            <span class="title">{{ data.title }}</span>
            <span class="description">{{ data.description }}</span>

            <Button
                @click="close"
                class="size-l"
                :name="`${data.close}${ data.timer !== null ? ` (${data.timer})` : '' }`"
            />
        </template>
    </BaseModal>
</template>

<script setup>
import { onMounted, reactive } from 'vue';

import BaseModal from '🔗/components/modals/BaseModal.vue';
import Button from '🔗/components/ui/Button.vue';
import IconButton from '🔗/components/ui/IconButton.vue';

import stores from '@/stores';
const modals = stores.modals();

const data = reactive({
    title: '',
    description: '',
    close: '',
    timer: null
});

const props = defineProps({
    name: {
        type: String,
        default: 'success'
    }
});

// =)
const animateItAgainPlease = (e) => {
    e?.target?.classList.remove('animate-1');
    setTimeout(() => {
        e?.target?.classList.add('animate-1');
    });
}

const close = () => {
    modals.close(props.name);
}

const showTimer = () => {
    if (data.timer) {
        setTimeout(() => {
            data.timer -= 1;

            if (!data.timer) {
                close();
            } else {
                showTimer();
            }
        }, 1000);
    }
}

onMounted(() => {
    const payload = modals.getData(props.name);
    data.title = payload?.title;
    data.description = payload?.description;
    data.close = payload?.close;

    if (payload?.timer) {
        data.timer = payload.timer;
        showTimer();   
    }
});

</script>

<style lang="scss">
    .modal-success {
        max-width: 380px;
    }
</style>

<style lang="scss" scoped>
    .round {
        margin: 20px auto 0;
        flex-shrink: 0;
    }
    .title {
        font: var(--font-h5);
        text-align: center;
        font-weight: bold;
        color: var(--dark-500);
    }

    .description {
        font: var(--font-body-2);
        text-align: center;
        color: var(--dark-500);
    }

    .size-l {
        margin-top: 20px;
    }
</style>
